import { useForm } from "react-hook-form";
import { History } from "lucide-react";

import DateInput from "../../../../components/UI/PageInput/DateInput";
import PrimaryButton from "../../../../components/UI/buttonUI/PrimaryButton";
import { FACTORY_CHECKPOINT_UPDATE_REVIEW_HISTORY } from "../../../../api/allApi_List";
import { formatDateString } from "../../../../functions/dateTime/formatDateString";
import CylinderDropdown from "../../../../components/UI/PageInput/CylinderDropdown";

const JobCardReviewHistorySelector = ({
  historyLoaded,
  getHistory,
  setupData,
}) => {
  const {
    register,
    setValue,
    watch,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      from: "",
      to: "",
    },
  });

  const { from, to, id } = watch();

  const onSubmit = () => {
    getHistory(
      `${FACTORY_CHECKPOINT_UPDATE_REVIEW_HISTORY}${id}/${formatDateString(from)}/${formatDateString(to)}`,
    );
  };
  return (
    <div className="bg-white px-5 py-2 rounded-lg border-1 border-dBlue-100 max-lg:p-3">
      <p className="font-figtreeMedium">Select cylinder and date range</p>
      <form onSubmit={(e) => handleSubmit(onSubmit)(e)}>
        <div className="md:flex md:gap-2 items-center">
          <div className="md:w-[30%]">
            <CylinderDropdown
              label="Cylinder No.*"
              name={`id`}
              options={setupData}
              setValue={setValue}
              control={control}
              error={errors.id}
            />
          </div>
          <div className="flex gap-1">
            <DateInput
              label="From *"
              name={"from"}
              value={from}
              setValue={setValue}
              register={{
                ...register("from", {
                  required: "Please select start date",
                }),
              }}
              error={errors.from}
              disableFutureDays={true}
            />
            <DateInput
              label="To *"
              name={"to"}
              value={to}
              setValue={setValue}
              register={{
                ...register("to", {
                  required: "Please select end date",
                }),
              }}
              error={errors.to}
              disableFutureDays={true}
            />
          </div>
          <PrimaryButton
            btnText={historyLoaded ? "Loading..." : "Get History"}
            loading={historyLoaded}
            Icon={History}
            size={18}
          />
        </div>
      </form>
    </div>
  );
};

export default JobCardReviewHistorySelector;
